/**
 * App configuration — single source of truth for the backend URL.
 *
 * Set REACT_APP_API_URL in frontend/.env to point at a deployed backend, e.g.
 *   REACT_APP_API_URL=https://tally-api.example.com/api
 * Leave it unset for local development: the CRA dev proxy in package.json
 * forwards the relative default ("/api") to http://localhost:5001.
 *
 * NOTE: create-react-app inlines REACT_APP_* at BUILD time, so re-run
 * `npm run build` (or restart `npm start`) after changing .env.
 */

// Accepts ".../api", ".../api/", the older ".../api/dashboard" form, and a bare
// origin with no path at all.
//
// WHY THE "/api" IS APPENDED RATHER THAN REQUIRED:
//   Every backend route lives under /api (see backend/src/server.js), but
//   setting REACT_APP_API_URL to just the origin — "https://api.tallydash.in"
//   instead of "https://api.tallydash.in/api" — is the natural mistake to make,
//   and it fails in a way that looks like a CORS or server problem rather than a
//   config typo: the browser reports "404 Endpoint not found" against a URL that
//   is missing one path segment, which is easy to stare past. Normalising both
//   forms to the same value removes the entire class of error.
const normalizeRoot = (url) => {
  const trimmed = url.replace(/\/+$/, '').replace(/\/dashboard$/, '');
  return /\/api$/.test(trimmed) ? trimmed : `${trimmed}/api`;
};

export const API_ROOT = normalizeRoot(process.env.REACT_APP_API_URL || '/api');

export const API_DASHBOARD = `${API_ROOT}/dashboard`;
export const API_DB = `${API_ROOT}/db`;
export const API_SYNC = `${API_ROOT}/sync`;

export const REQUEST_TIMEOUT = Number(process.env.REACT_APP_API_TIMEOUT) || 10000;
